import script from "./TableGenerator.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableGenerator.vue?vue&type=script&lang=ts&setup=true"

import "./TableGenerator.vue?vue&type=style&index=0&id=372c6730&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372c6730"]])

export default __exports__